import {
  LOOKUP_REGISTRATION_EVENT,
  LOOKUP_REGISTRATION_EVENT_CLEAR,
  SELECT_REGISTRATION_EVENT,
  CREATE_EVENT_REGISTRATION,
  CREATE_BULK_EVENT_REGISTRATION,
  FETCH_EVENT_REGISTRATIONS,
  FETCH_EVENT_REGISTRATIONS_FOR_EVENT,
  DELETE_EVENT_REGISTRATION,
  RESET_CREATE_SUCCESS,
} from '../actions/action_event_registration';

const INITIAL_STATE = {
  lookupEvents: [],
  lookupEvent: null,
  selectedEvent: null,
  lookupError: null,
  registrations: [],
  eventRegistrations: [],
  createSuccess: false,
  createError: null,
  deleteSuccess: false,
};

export default function (state = INITIAL_STATE, action) {
  Object.freeze(state);

  switch (action.type) {
    case LOOKUP_REGISTRATION_EVENT:
      if (action.error) {
        return {
          ...state,
          lookupEvents: [],
          lookupEvent: null,
          selectedEvent: null,
          lookupError:
            action.payload?.response?.data?.error || 'Event not found',
        };
      }
      {
        const events = action.payload.data.events;
        const autoSelected = events.length === 1 ? events[0] : null;
        return {
          ...state,
          lookupEvents: events,
          lookupEvent: autoSelected,
          selectedEvent: autoSelected,
          lookupError: null,
        };
      }

    case SELECT_REGISTRATION_EVENT:
      return {
        ...state,
        lookupEvent: action.payload,
        selectedEvent: action.payload,
      };

    case LOOKUP_REGISTRATION_EVENT_CLEAR:
      return {
        ...state,
        lookupEvents: [],
        lookupEvent: null,
        selectedEvent: null,
        lookupError: null,
        createSuccess: false,
        createError: null,
      };

    case CREATE_EVENT_REGISTRATION:
      if (action.error) {
        return {
          ...state,
          createSuccess: false,
          createError:
            action.payload?.response?.data?.error || 'Registration failed',
        };
      }
      return {
        ...state,
        createSuccess: true,
        createError: null,
        registrations: [
          action.payload.data.registration,
          ...state.registrations,
        ],
        eventRegistrations: [
          action.payload.data.registration,
          ...state.eventRegistrations,
        ],
      };

    case CREATE_BULK_EVENT_REGISTRATION:
      if (action.error) {
        return {
          ...state,
          createSuccess: false,
          createError:
            action.payload?.response?.data?.error || 'Registration failed',
        };
      }
      return {
        ...state,
        createSuccess: true,
        createError: null,
        registrations: [
          ...action.payload.data.registrations,
          ...state.registrations,
        ],
        eventRegistrations: [
          ...action.payload.data.registrations,
          ...state.eventRegistrations,
        ],
      };

    case FETCH_EVENT_REGISTRATIONS:
      if (action.error) {
        return { ...state };
      }
      return {
        ...state,
        registrations: action.payload.data.registrations,
      };

    case FETCH_EVENT_REGISTRATIONS_FOR_EVENT:
      if (action.error) {
        return { ...state };
      }
      return {
        ...state,
        eventRegistrations: action.payload.data.registrations,
        deleteSuccess: false,
      };

    case RESET_CREATE_SUCCESS:
      return { ...state, createSuccess: false, createError: null };

    case DELETE_EVENT_REGISTRATION:
      if (action.error) {
        return { ...state };
      }
      return {
        ...state,
        deleteSuccess: true,
        registrations: state.registrations.filter(
          (r) => r.id !== action.meta.id,
        ),
        eventRegistrations: state.eventRegistrations.filter(
          (r) => r.id !== action.meta.id,
        ),
      };

    default:
      return state;
  }
}
